export enum NotificationType {
  // General Notifications
  accountVerified = "ACCOUNT_VERIFIED",
  profileViewed = "PROFILE_VIEWED",
  ENTITY_PROFILE_VIEWED = "ENTITY_PROFILE_VIEWED",
  mentionInPost = "MENTION_IN_POST",
  mentionInComment = "MENTION_IN_COMMENT",
  mentionInReply = "MENTION_IN_REPLY",
  likedPost = "LIKED_POST",
  likedComment = "LIKED_COMMENT",
  addCommentOnPost = "ADD_COMMENT",
  reply = "REPLY",
  repost = "REPOST",
  share = "SHARE",
  FOLLOW = "FOLLOW",
  professionalRequest = "PROFESSIONAL_REQUEST",
  friendRequest = "FRIEND_REQUEST",
  requestAccepted = "REQUEST_ACCEPTED",
  minorReceivesProfessionalRequest = "MINOR_RECEIVES_PROFESSIONAL_REQUEST",
  minorSendsProfessionalRequest = "MINOR_SENDS_PROFESSIONAL_REQUEST",
  minorDeleteRequestAccepted = "MINOR_DELETE_REQUEST_ACCEPTED",
  minorAddRequestAccepted = "MINOR_ADD_REQUEST_ACCEPTED",
  minorAddRequestApproved = "MINOR_ADD_REQUEST_APPROVED",
  minorDeclineRequest = "MINOR_DECLINE_REQUEST",
  minorDeleteRequest = "MINOR_DELETE_REQUEST",
  guardianFormAccept = "GUARDIAN_FORM_ACCEPT",
  guardianFormReject = "GUARDIAN_FORM_REJECT",
  reviewReceived = "REVIEW_RECEIVED",
  reviewAccepted = "REVIEW_ACCEPTED",
  reviewUpdated = "REVIEW_UPDATED",
  reviewRequestRevision = "REVIEW_REQUEST_REVISION",
  challenge_invitation = "CHALLENGE_INVITATION",
  challenge_joined = "CHALLENGE_JOINED",

  // Events
  MATCH_JOIN_REQUEST = "GAME_JOIN_REQUEST",
  TRAINING_JOIN_REQUEST = "TRAINING_JOIN_REQUEST",
  MATCH_INVITATION = "MATCH_INVITATION",
  EVENT_INVITATION = "EVENT_INVITATION",
  TRAINING_INVITATION = "TRAINING_INVITATION",

  EVENT_JOIN_REQUEST = "EVENT_JOIN_REQUEST",
  EVENT_JOIN_REQUEST_ACCEPTED = "EVENT_JOIN_REQUEST_ACCEPTED",
  EVENT_JOIN_REQUEST_DECLINED = "EVENT_JOIN_REQUEST_DECLINED",
  ACCEPT_EVENT_INVITATION = "ACCEPT_EVENT_INVITATION",
  REJECT_EVENT_INVITATION = "REJECT_EVENT_INVITATION",
  EVENT_PLAYER_REMOVED = "EVENT_PLAYER_REMOVED",

  PLAYER_LEFT_MATCH = "PLAYER_LEFT_MATCH",
  PLAYER_LEFT_TRAINING = "PLAYER_LEFT_TRAINING",

  MATCH_CANCELLED = "MATCH_CANCELLED",
  TRAINING_CANCELLED = "TRAINING_CANCELLED",

  // Mass Offer Notifications
  PROFILE_OFFER = "PROFILE_OFFER",
  PROFILE_OFFER_RESPONSE = "PROFILE_OFFER_RESPONSE",

  OFFER_EXPIRED = "OFFER_EXPIRED",
  OFFER_NEAR_EXPIRY = "OFFER_NEAR_EXPIRY",
}
